<template lang="pug">
	.date-picker-wrapper
		button.btn.btn-primary(v-pseudo-modal-show="'date-picker-dropdown' + '-' + parentName")
			span {{buttonTitle}}
			i.fa.fa-calendar(:style="{'font-size': '17px'}")
		.date-picker(v-pseudo-modal="'date-picker-dropdown' + '-' + parentName")
			.pickers
				.left-date-picker(:id="'start-date' + '-' + parentName")

</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";


import dayjs         from "dayjs";
import AirDatepicker from "air-datepicker";
import localeEn 		from 'air-datepicker/locale/en';

export default {
	name: 'DatePicker',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {}
	},
	props: ['updateFunction', 'parentName', 'timeFilter'],
	watch: {
		timeFilter(newVal) {
			this.updateSelectedDates(newVal);
			this.updateButtonTitle();
			this.updateDateRange(this.datePicker.selectedDates);
		},
	},
	data() {
		this.datePicker = false;
		return {
			buttonTitle: 'CUSTOM',
			showed: true
		}
	},
	created() {
		Broadcast.on(`Pseudo Modal Showed date-picker-dropdown-${this.parentName}`, () => {
			if (!this.datePicker || !this.datePicker.selectedDates || !this.datePicker.selectedDates.length) {
				this.buttonTitle = 'CUSTOM';
				return;
			}
			this.updateDateRange(this.datePicker.selectedDates);
		}, this);
	},
	mounted() {
		this.datePicker = new AirDatepicker('#start-date-' + this.parentName, {
			locale: localeEn,
			range: true,
			multipleDatesSeparator: ' - ',
			onSelect: result => {
				if (!result || !result.date || !result.date.length) {
					this.buttonTitle = 'CUSTOM';
					return;
				}
				this.updateButtonTitle();
				this.updateDateRange(result.date);
			}
		});

		if (this.timeFilter) {
			this.updateSelectedDates(this.timeFilter);
			this.updateButtonTitle();
		}
	},
	methods: {
		collectData() {},

		updateDateRange(dates) {

			let timeRange;
			if (dates.length === 1) {
				timeRange = dayjs(dates[0]).startOf('day').toISOString() + '|' + dayjs(dates[0]).endOf('day').toISOString();
			} else {
				timeRange = dayjs(dates[0]).startOf('day').toISOString() + '|' + dayjs(dates[1]).endOf('day').toISOString();
			}
			this.updateFunction(timeRange);

		},

		updateSelectedDates(dateRange) {
			this.datePicker.clear({silent: true});
			switch (dateRange) {
				case 'today':
					this.datePicker.selectDate([dayjs(Date.now()).toDate()], {silent: true});
					break;
				case 'yesterday':
					this.datePicker.selectDate([dayjs(Date.now()).subtract(1, 'day').toDate()], {silent: true});
					break;
				case 'last 3 days':
					this.datePicker.selectDate([dayjs(Date.now()).subtract(2, 'day').toDate(), new Date(Date.now())], {silent: true});
					break;
				case 'last 7 days':
					this.datePicker.selectDate([dayjs(Date.now()).subtract(6, 'day').toDate(), new Date(Date.now())], {silent: true});
					break;
				case 'this month':
					this.datePicker.selectDate([dayjs(Date.now()).startOf('month').toDate(), dayjs(Date.now()).endOf('month').toDate()], {silent: true});
					break;
				case 'last month':
					let start = dayjs(Date.now()).subtract(1, "month").startOf('month').toDate();
					let end = dayjs(Date.now()).subtract(1, "month").endOf('month').toDate();
					this.datePicker.selectDate([start, end], {silent: true});
					break;
			}
		},

		updateButtonTitle() {

			this.buttonTitle = this.datePicker.selectedDates.map(date => dayjs(date).format('D MMM YYYY')).join(' - ');

		}
	}
}

</script>

<style lang="sass">

	.date-picker-wrapper
		position: relative

		button.btn.btn-primary
			height: 100%
			width: 250px
			background-color: unset
			border: 2px solid #66609d
			border-radius: 15px
			color: #aaa1f5
			display: flex
			flex-direction: row
			justify-content: space-evenly

	.date-picker
		display: flex
		flex-direction: column
		gap: 40px
		position: absolute
		top: 40px
		left: 10px
		background-color: #3a4149

		>.pickers
			display: flex
			flex-direction: row
			gap: 40px

			.air-datepicker.-inline-
				background: rgb(201,187,255)
				background: linear-gradient(-117deg, rgba(201,187,255,1) 0%, rgba(201,187,255,1) 100%)

				.air-datepicker-body--cells.-days-
					font-weight: bold

				.air-datepicker-cell.-day-.-in-range-
					color: black
				.air-datepicker-cell.-selected-.-range-to-
					color: black
					&:hover
						background-color: #66609d
				.air-datepicker-cell.-selected-.-range-from-
					color: black
					&:hover
						background-color: #66609d

				.air-datepicker-nav--title
					font-weight: bold
					color: black

					>i
						color: black

.creative-dashboard .air-datepicker
	--adp-background-color-hover: #9E98C9
	--adp-nav-arrow-color: black
	--adp-color: black
	--adp-cell-background-color-selected: #36374a
	--adp-cell-background-color-selected-hover: #36374a
	--adp-cell-background-color-in-range: #36374a
	--adp-color-other-month: #5b5b5b
	--adp-day-name-color: #4a79e4
	--adp-color-current-date: blue
	--adp-background-color-in-range: #36374a
	--adp-background-color-selected-other-month: #36374a


</style>
